import { defineAction } from '~/prix'
import alertDeleteAction from './alertDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const alertDeleteDefinition = defineAction({
  ...alertDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default alertDeleteDefinition
